class HistoryStorage {
	#state = {};

	constructor() {
		this.state = history.state || {};
	}

	getItem( key ) {
		return this.state[ key ] ?? null;
	}

	setItem( key, value ) {
		this.state = {
			...history.state,
			[ key ]: value,
		};

		const uri = location.href.substring( location.origin.length );

		history.replaceState( this.state, '', uri );
	}
}

export default new HistoryStorage();
